import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="space-y-4" data-id="element-167">
      {items.map((item, index) => <div key={index} className="bg-white border border-warm-200 rounded-2xl overflow-hidden hover:border-teal-300 transition-colors shadow-sm" data-id="element-168">
          <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-warm-50 transition-colors" aria-expanded={openIndex === index} data-id="element-169">
            <span className="font-bold text-ink-900 pr-4 text-lg" data-id="element-170">
              {item.question}
            </span>
            <motion.div animate={{
          rotate: openIndex === index ? 180 : 0
        }} transition={{
          duration: 0.2
        }} className="flex-shrink-0 bg-warm-100 p-1.5 rounded-full" data-id="element-171">
              <ChevronDown className="h-5 w-5 text-ink-500" data-id="element-172" />
            </motion.div>
          </button>

          <AnimatePresence data-id="element-173">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="overflow-hidden" data-id="element-174">
                <div className="px-6 pb-6 pt-2 text-ink-500 leading-relaxed border-t border-warm-100" data-id="element-175">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}